import { makeAutoObservable, runInAction } from "mobx";
import store from "./store";

export default class ApplicantTrackingStore {
  constructor() {
    makeAutoObservable(this);
  }

  loading = false;
  error = false;

  handleUpdateApplicationStatus = async (id, status, apiFunction, successMessage, notificationType) => {
    this.loading = true;
    try {
      await apiFunction.updateApplicationStatus(id, status);

      const getTitleByStatus = (status) => {
        switch (status) {
          case "Approved":
            return "Approved";
          case "Declined":
            return "Declined";
          default:
            return notificationType === "success" ? "Success" : "Error";
        }
      };

      const getNotificationTypeByStatus = (status) => {
        switch (status) {
          case "Approved":
            return "success";
          case "Declined":
            return "error";
          default:
            return notificationType;
        }
      };

      const title = getTitleByStatus(status);
      const type = getNotificationTypeByStatus(status);

      store.notificationStore.showNotification(successMessage, type, {
        title,
        duration: 5000,
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
        this.error = true;
      });
      const errorMessage = error.response?.data?.message || error.response?.data || "An error occurred";

      store.notificationStore.showNotification(errorMessage, "error", {
        title: "Error",
        duration: 5000,
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
